"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsImperialMeasurementUsed = void 0;
/* eslint-disable import/prefer-default-export */
const typesafe_actions_1 = require("typesafe-actions");
const consts_1 = require("./consts");
exports.setIsImperialMeasurementUsed = (0, typesafe_actions_1.createAction)(consts_1.UNIT_OF_MEASUREMENT)();
